import React, { useEffect, useState, useRef } from 'react';
import '../Shared/product.css';
import './productdetail.css';
import 'aos/dist/aos.css';
import { useParams } from 'react-router-dom';
import { HashLink as Link } from 'react-router-hash-link';
import { resolveProductImage } from '../../../utils/resolveProductImage';
import { apiUrl } from '../../../utils/apiBase';

// Utility function for slug normalization
const slugify = (name) =>
  name
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/[^\w-]+/g, '');

const videoLinks = {
  'amrit-pey': "<iframe width='560' height='315' src='https://www.youtube.com/embed/Wgno3CfOwQc?si=4jg_Zq7O2jlMA9MB' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe>",
  'jaggery':
    "<iframe width='560' height='315' src='https://www.youtube.com/embed/cAEHHEho41M?si=1F2Ig8fGCk6W3Qpz' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe>",
  // Add more product slugs and YouTube video links as needed
};

// A mapping of product slugs to ingredients
const ingredientsList = {
  'amrit-pey': [
    "Dried Ginger (Sonth).................................................... 50 grams",
    "Black Pepper............................................................ 50 grams",
    "Long Pepper (Choti Peepal)...............................................25 grams",
    "Cinnamon ............................................................... 25 grams",
    "Green Cardamom.......................................................... 25 grams",
    "Fennel Seeds............................................................ 50 grams",
    "Carom Seeds (Ajwain).................................................... 25 grams",
    "Cloves.................................................................. 25 grams",
    "Licorice (Mulethi) ..................................................... 100 grams",
    "Ashwagandha............................................................. 25 grams",
    "Arjuna Bark............................................................. 50 grams",
    "Pomegranate Peel........................................................ 50 grams",
    "Fenugreek Seeds......................................................... 50 grams",
    "Holy Basil Leaves (Tulsi) .............................................. 25 grams",
  ],
  'jaggery': [
    "Sugarcane juice....................................................100 grams",
    "Natural molasses....................................................trace amounts"
  ],
  'khand': [
    "Sugarcane extract....................................................100 grams",
    "Natural minerals....................................................trace amounts"
  ],
  // Add more product slugs and ingredients as needed
};

function ProductDetail() {
  const { productName } = useParams(); // Extract productName from URL
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const videoLinksRef = useRef(videoLinks);
  const ingredientsListRef = useRef(ingredientsList);

  useEffect(() => {
    // Scroll to top when the component mounts
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const normalizedProductName = slugify(productName);

    fetch(apiUrl('anuyog-products-list/'))
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch products');
        }
        return response.json();
      })
      .then((data) => {
        const products = Array.isArray(data) ? data : (data.data ?? data.results ?? []);
        const matchedProduct = products.find(
          (p) =>
            slugify(p.name) === normalizedProductName ||
            p.slug === normalizedProductName
        );

        if (matchedProduct) {
          setProduct({
            ...matchedProduct,
            img: resolveProductImage(matchedProduct.image),
            video: videoLinksRef.current[normalizedProductName] || null,
            ingredients: ingredientsListRef.current[normalizedProductName] || null,
          });
        } else {
          throw new Error('Product not found');
        }
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [productName]);

  if (loading) {
    return <div>Loading product details...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!product) {
    return <div>Product not found</div>;
  }

  return (
    <>
      <section className="product_details-section">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <h1 className="text-start product-title">{product.name}</h1>
              <h2 className='fw-bold text-start'>₹ {product.price1}</h2>
              <h5 className='text-start fw-bold'> <strong>MRP Inclusive of all taxes</strong></h5>

              <h3 className='fw-bold text-start mt-4' style={{ color: '#a04635' }}>About {product.name}</h3>
              <p className="product-description">{product.description}</p>
              {/* <a
                href={`https://wa.me/+917892307418?text=I%20want%20to%20buy%20${encodeURIComponent(product.name)}`}
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" className="btn mt-3 me-md-5">
                  Order via WhatsApp
                </button>
              </a> */}
              <Link
                to="/contact"
                state={{ showEmailForm: true,prefillMessage: `I want to buy ${product.name}` }}
              >
                <button type="button" className="btn fw-bold mt-3 me-md-5">
                Place an Order 
                </button>
              </Link>
              {product.video && (
                <div className="product-detail-video-embed mt-4">
                  <h2 className="fw-bold text-start mb-4 mt-5">
                    <strong style={{ color: '#9D3B24' }}>Learn More About Product</strong>
                  </h2>
                  <div
                    className="mb-4"
                    dangerouslySetInnerHTML={{ __html: product.video }}
                  />
                </div>
              )}
            </div>
            <div className="details_image col-md-6">
              <div>
                <img src={product.img} alt={product.name} />
              </div>
              <h2 className="fw-bold mt-4">WHAT'S INSIDE</h2>
              {product.ingredients && (
                <>
                  <h4>
                    <strong>Ingredients</strong>
                  </h4>
                  <ul className="fw-bold text-start">
                    {product.ingredients.map((ingredient, index) => (
                      <li key={index}>{ingredient}</li>
                    ))}
                  </ul>
                </>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ProductDetail;
